import { Box, createStyles, JsonInput, JsonInputProps } from "@mantine/core";
import React from "react";
import { RpiAlert, RpiLabelText } from "@rpi/openapi-core";
import { tokens } from "@blurb/codex-react";

const useStyles = createStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing["2"],
  },
  input: {
    padding: tokens.spacing["2"],
    color: tokens.color.semantic.text.bold,
    textAlign: "left",
    fontSize: tokens.font.size.base,
    fontFamily: tokens.font.family.mono,
    fontWeight: theme.other.fontWeights.normal,
    lineHeight: tokens.font.lineHeight.normal,
    borderColor: tokens.color.semantic.border.subtle,
    borderRadius: tokens.radius.base,
    "&:hover": {
      background: tokens.color.semantic.bg.inputHover,
    },
    "&::placeholder": {
      color: tokens.color.semantic.text.subtle,
    },
    "&:focus-visible": {
      borderColor: tokens.color.semantic.border.subtle,
      outline: `2px solid ${tokens.color.semantic.border.focus}`,
    },
    "&:disabled": {
      backgroundColor: tokens.color.semantic.bg.neutralDisabled,
      color: tokens.color.semantic.text.disabled,
      opacity: "unset",
    },
    "&[data-error]": {
      borderColor: tokens.color.semantic.border.danger,
    },
  },
}));

interface RpaJsonInputProps extends JsonInputProps {
  error?: string;
}

export const RpaJsonInput: React.FC<RpaJsonInputProps> = ({ label, error, ...props }) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.container}>
      <RpiLabelText>{label}</RpiLabelText>
      <JsonInput size="md" classNames={{ input: classes.input }} data-error={!!error || undefined} {...props} />
      {error && <RpiAlert>{error}</RpiAlert>}
    </Box>
  );
};
